import { render, staticRenderFns } from "./gtr-empty-state.vue?vue&type=template&id=2ea4fed0"
import script from "./gtr-empty-state.ts?vue&type=script&lang=ts&external"
export * from "./gtr-empty-state.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports